import {
  type CreateOrUpdateUserQuestRequest,
  postUserQuests,
  type UserQuestData,
} from "Infrastructure/Api/Api";
import {
  type ApiCallError,
  processResponse,
} from "Infrastructure/Api/ApiUtils";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { userQuestKeys, userQuestMutationKeys } from "./requestKeys";

export const useUserQuestMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<
    UserQuestData,
    ApiCallError,
    CreateOrUpdateUserQuestRequest
  >({
    mutationKey: userQuestMutationKeys.createOrUpdate,
    mutationFn: processResponse((command) => postUserQuests(command)),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: userQuestKeys.lists(),
      });
    },
  });
};
